import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';

const VERT       = '#1B5E20';
const VERT_CLAIR = '#E8F5E9';
const GRIS_BORD  = '#E0E0E0';

// ─── Icônes sections principales ────────────────────────────────────────────

const IcoPostes = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="4" r="2" stroke="currentColor" strokeWidth="1.8"/>
    <circle cx="4" cy="18" r="2" stroke="currentColor" strokeWidth="1.8"/>
    <circle cx="20" cy="18" r="2" stroke="currentColor" strokeWidth="1.8"/>
    <path d="M12 6v4M12 10H4v6M12 10h8v6"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IcoReferentiel = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="3" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.8"/>
    <rect x="14" y="3" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.8"/>
    <rect x="3" y="14" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.8"/>
    <rect x="14" y="14" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.8"/>
  </svg>
);

const IcoConfig = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8"/>
    <path d="M12 2v2M12 20v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M2 12h2M20 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);

// ─── Icônes sous-sections Configuration RH ──────────────────────────────────

const IcoIPM = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M12 2a5 5 0 0 0-5 5v3H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-3V7a5 5 0 0 0-5-5z"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 14v2M11 15h2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);

const IcoPrets = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <rect x="2" y="6" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="1.8"/>
    <path d="M16 6V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v1" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    <path d="M12 12v4M10 14h4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);

const IcoNotifs = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.73 21a2 2 0 0 1-3.46 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);

const IcoImport = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M17 8l-5-5-5 5M12 3v12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IcoStatuts = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="7" cy="7" r="1.5" fill="currentColor"/>
  </svg>
);

const IcoMotifs = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IcoAges = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/>
    <path d="M12 7v5l3 3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);

const IcoProvisions = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <rect x="2" y="6" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="1.8"/>
    <path d="M2 10h20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    <path d="M6 14h3M15 14h3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    <path d="M6 3l3 3M18 3l-3 3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);

const IcoRefs = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M3 6h18M3 12h18M3 18h18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);

// ─── Sections principales du hub ────────────────────────────────────────────

const SECTIONS = [
  {
    id: 'postes',
    label: 'Postes & Organigramme',
    desc: 'Gérer les postes, affecter des titulaires, visualiser l\'organigramme et consulter la matrice des permissions.',
    Ico: IcoPostes,
    path: '/parametres/postes',
  },
  {
    id: 'referentiel',
    label: 'Référentiel',
    desc: 'Administrer les sites, les départements et les services de l\'organisation.',
    Ico: IcoReferentiel,
    path: '/parametres',
  },
  {
    id: 'config-rh',
    label: 'Configuration RH',
    desc: 'Paramétrer les modules RH : IPM, prêts, notifications, imports, statuts, motifs et provisions.',
    Ico: IcoConfig,
  },
];

// ─── Sous-sections Configuration RH (toutes dans /parametres) ───────────────

const CONFIG_ITEMS = [
  { id: 'ipm',           label: 'IPM',                      Ico: IcoIPM,       desc: 'Paramètres IPM datés et sourcés (habilitation IPM requise).', path: '/ipm?onglet=parametres' },
  { id: 'prets-sogas',   label: 'Prêts SOGAS',              Ico: IcoPrets,     desc: 'Configurer les règles, plafonds et périodes de remboursement des prêts.', path: '/parametres' },
  { id: 'notifications', label: 'Notifications',            Ico: IcoNotifs,    desc: 'Gérer les destinataires et les événements déclencheurs d\'alertes.', path: '/parametres' },
  { id: 'import-export', label: 'Import / Export',          Ico: IcoImport,    desc: 'Importer des employés en masse et exporter les données RH.', path: '/parametres' },
  { id: 'statuts',       label: 'Statuts employé',          Ico: IcoStatuts,   desc: 'Administrer les statuts actif, inactif, suspendu et archivé.', path: '/parametres' },
  { id: 'motifs',        label: 'Motifs de départ',         Ico: IcoMotifs,    desc: 'Lister et libeller les motifs de fin de contrat et de départ.', path: '/parametres' },
  { id: 'ages',          label: 'Ages & alertes retraite',  Ico: IcoAges,      desc: 'Paramétrer les seuils d\'alerte et les âges légaux de départ en retraite.', path: '/parametres' },
  { id: 'provisions',    label: 'Provisions retraite',      Ico: IcoProvisions,desc: 'Définir les tranches de calcul et les taux des provisions pour retraite.', path: '/parametres' },
  { id: 'refs',          label: 'Référentiels secondaires', Ico: IcoRefs,      desc: 'Sites, départements et services de l\'organisation.', path: '/parametres' },
];

// ─── Composant nav item ───────────────────────────────────────────────────────

function NavItem({ section, actif, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        width: '100%',
        padding: '10px 20px',
        background: actif ? VERT_CLAIR : 'none',
        borderLeft: actif ? `3px solid ${VERT}` : '3px solid transparent',
        border: 'none',
        borderLeft: actif ? `3px solid ${VERT}` : '3px solid transparent',
        cursor: 'pointer',
        fontSize: 13,
        fontWeight: actif ? 600 : 500,
        color: actif ? VERT : '#374151',
        textAlign: 'left',
        minHeight: 44,
        fontFamily: 'inherit',
        transition: 'background 0.12s',
      }}
      onMouseEnter={e => { if (!actif) e.currentTarget.style.background = '#F0F7F0'; }}
      onMouseLeave={e => { if (!actif) e.currentTarget.style.background = 'none'; }}
    >
      <span style={{ color: actif ? VERT : '#6B7280', flexShrink: 0 }}>
        <section.Ico />
      </span>
      {section.label}
    </button>
  );
}

// ─── Carte de section ────────────────────────────────────────────────────────

function CarteSection({ section, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        background: '#fff',
        border: `1px solid ${GRIS_BORD}`,
        borderRadius: 12,
        padding: '28px 24px',
        textAlign: 'left',
        cursor: 'pointer',
        fontFamily: 'inherit',
        minHeight: 44,
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        transition: 'box-shadow 0.15s, border-color 0.15s',
      }}
      onMouseEnter={e => {
        e.currentTarget.style.boxShadow = '0 4px 14px rgba(0,0,0,0.10)';
        e.currentTarget.style.borderColor = VERT;
      }}
      onMouseLeave={e => {
        e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.06)';
        e.currentTarget.style.borderColor = GRIS_BORD;
      }}
    >
      <div style={{
        width: 44,
        height: 44,
        borderRadius: 10,
        background: VERT_CLAIR,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: VERT,
        marginBottom: 16,
      }}>
        <section.Ico />
      </div>
      <div style={{ fontWeight: 700, fontSize: 15, color: '#1a1a1a', marginBottom: 8 }}>
        {section.label}
      </div>
      <div style={{ fontSize: 13, color: '#64748B', lineHeight: 1.6 }}>
        {section.desc}
      </div>
      <div style={{
        marginTop: 20,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        fontSize: 13,
        fontWeight: 600,
        color: VERT,
      }}>
        Ouvrir
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
          <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
    </button>
  );
}

// ─── Page principale ─────────────────────────────────────────────────────────

export default function GouvernancePage() {
  const navigate = useNavigate();
  const [sectionActive, setSectionActive] = useState(null);

  const handleNavClick = (section) => {
    if (section.path) {
      navigate(section.path);
    } else {
      setSectionActive(section.id);
    }
  };

  const estConfigRH = sectionActive === 'config-rh';

  return (
    <Layout>
      <div style={{ display: 'flex', background: '#f7f7f7', minHeight: '100%' }}>

        {/* ── Navigation latérale ────────────────────────────────── */}
        <div style={{
          width: 236,
          background: '#fff',
          borderRight: `1px solid ${GRIS_BORD}`,
          paddingTop: 20,
          flexShrink: 0,
        }}>
          <div style={{
            padding: '0 20px 14px',
            fontSize: 10,
            fontWeight: 700,
            color: '#94A3B8',
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
          }}>
            Sections
          </div>
          {SECTIONS.map(s => (
            <NavItem
              key={s.id}
              section={s}
              actif={sectionActive === s.id}
              onClick={() => handleNavClick(s)}
            />
          ))}
        </div>

        {/* ── Contenu principal ──────────────────────────────────── */}
        <div style={{ flex: 1, padding: '36px 44px' }}>

          {estConfigRH ? (
            /* ── Sous-vue Configuration RH ── */
            <>
              {/* Fil d'Ariane + retour */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 28 }}>
                <button
                  onClick={() => setSectionActive(null)}
                  style={{
                    background: 'none', border: `1px solid ${GRIS_BORD}`, borderRadius: 8,
                    padding: '6px 12px', cursor: 'pointer', fontSize: 12, color: '#555',
                    display: 'flex', alignItems: 'center', gap: 6, fontFamily: 'inherit',
                    minHeight: 44,
                  }}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <path d="M19 12H5M12 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Accueil
                </button>
                <span style={{ color: '#CBD5E1', fontSize: 14 }}>/</span>
                <span style={{ fontSize: 13, color: '#64748B', fontWeight: 500 }}>Configuration RH</span>
              </div>

              {/* En-tête sous-vue */}
              <div style={{ marginBottom: 28 }}>
                <div style={{
                  display: 'inline-flex', alignItems: 'center', gap: 8,
                  background: VERT_CLAIR, borderRadius: 8, padding: '4px 12px', marginBottom: 14,
                }}>
                  <IcoConfig />
                  <span style={{ fontSize: 11, fontWeight: 700, color: VERT, letterSpacing: '0.04em' }}>
                    CONFIGURATION RH
                  </span>
                </div>
                <h1 style={{ fontSize: 20, fontWeight: 700, color: '#1a1a1a', margin: '0 0 8px', letterSpacing: '-0.01em' }}>
                  Configuration RH
                </h1>
                <p style={{ fontSize: 14, color: '#64748B', margin: 0, lineHeight: 1.6 }}>
                  Paramétrez les modules de gestion RH. Toutes ces sections sont accessibles depuis la page Paramètres.
                </p>
              </div>

              {/* Grille des 9 sous-sections */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
                gap: 16,
              }}>
                {CONFIG_ITEMS.map(item => (
                  <CarteSection key={item.id} section={item} onClick={() => navigate(item.path)} />
                ))}
              </div>
            </>
          ) : (
            /* ── Vue landing (accueil hub) ── */
            <>
              {/* En-tête */}
              <div style={{ marginBottom: 36 }}>
                <div style={{
                  display: 'inline-flex', alignItems: 'center', gap: 8,
                  background: VERT_CLAIR, borderRadius: 8, padding: '4px 12px', marginBottom: 14,
                }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <rect x="2" y="14" width="20" height="7" rx="1" stroke={VERT} strokeWidth="2"/>
                    <rect x="6" y="8" width="12" height="6" rx="1" stroke={VERT} strokeWidth="2"/>
                    <rect x="9" y="3" width="6" height="5" rx="1" stroke={VERT} strokeWidth="2"/>
                  </svg>
                  <span style={{ fontSize: 11, fontWeight: 700, color: VERT, letterSpacing: '0.04em' }}>
                    GOUVERNANCE RH
                  </span>
                </div>
                <h1 style={{
                  fontSize: 22, fontWeight: 700, color: '#1a1a1a',
                  margin: '0 0 10px', letterSpacing: '-0.01em',
                }}>
                  Centre de Gouvernance RH
                </h1>
                <p style={{ fontSize: 14, color: '#64748B', margin: 0, lineHeight: 1.6 }}>
                  Gérez la structure organisationnelle, les référentiels et la configuration des modules RH.
                </p>
              </div>

              {/* Cartes des 3 sections */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                gap: 16,
              }}>
                {SECTIONS.map(s => (
                  <CarteSection key={s.id} section={s} onClick={() => handleNavClick(s)} />
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
}
